import { updateActiveTab } from "@features/activeTabSlice";
import { useDispatch } from "react-redux";
import $ from "jquery";

const useUpdateModule = (activeTab: string) => {
    const dispatch = useDispatch();
    const updateModule = () => {
        dispatch(updateActiveTab(activeTab));
        $(".react-tabs__tab")
            .removeClass("react-tabs__tab--selected")
            .addClass("react-tabs__tab--disabled");
        $(`#${activeTab}-tab`)
            .removeClass("react-tabs__tab--disabled")
            .addClass("react-tabs__tab--selected");
    };
    return updateModule;
};

export default useUpdateModule;
